<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Service Details</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Service Details</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>


<div class="company-details-area pt-100">
  <div class="container" *ngIf="pservice">
      <div class="row">
          <div class="col-lg-8">
              <div class="company-details-item">

                  <div class="company-details-description">
                    <h3>{{pservice.name}}</h3>
                    <p><i class="icofont-location-pin"></i>{{pservice.addressLine}}</p>
                  </div>

                  <div class="company-details-description">
                      <h3>Description</h3>
                      <p>{{pservice.description}}</p>
                  </div>

                  <!-- Social Media Handles -->
                    <div class="company-details-find">
                      <h3>Media Handles:</h3>
                      <ul>
                        <div id="html-content">
                          <li *ngFor="let aa of handles">
                            <a *ngIf="aa.handle == 'Facebook'" href="https://web.facebook.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-facebook"></i> {{aa.handleDetail}}</a>
                            <a *ngIf="aa.handle == 'Twitter'" href="https://www.twitter.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-twitter"></i> {{aa.handleDetail}}</a>
                            <a *ngIf="aa.handle == 'Instagram'" href="https://www.instagram.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-instagram"></i> {{aa.handleDetail}}</a>
                            <a *ngIf="aa.handle == 'Linkedin'" href="https://www.linkedin.com/{{aa.handleDetail}}" target="_blank"><i class="icofont-linkedin"></i> {{aa.handleDetail}}</a>
                          </li>
                        </div>
                      </ul>
                    </div>

                  <div class="company-details-find">
                    <h3>Contact:</h3>

                    <ul >
                      <div id="html-content">
                        <li><a><i class="icofont-phone-circle"></i>{{pservice.primaryContactNumber}}</a></li>
                      </div>
                    </ul>
                  </div>

                  <div class="text-center">
                    <a *ngIf="is_default_user" class="job-details-btn" (click)="copyContact()">Copy Contact</a>
                    <a *ngIf="user && !is_default_user" class="job-details-btn" class="job-details-btn" routerLink="/edit_service/{{user.serviceId}}">Edit</a>
                  </div>

              </div>
          </div>

          <div *ngIf="is_default_user" class="col-lg-4">
              <div class="company-details-item">
                  <div class="single-resume-category">
                      <h3>Service Category</h3>

                      <ul>
                          <li>{{pservice.serviceCategory.name}}</li>
                      </ul>
                  </div>
              </div>
          </div>

          <div *ngIf="user && !is_default_user" class="col-lg-4">
            <div class="company-details-item">

                <div class="single-resume-category">
                    <h3>Profile Information</h3>

                    <ul>
                        <li>{{user.fullname}}</li>
                        <li>{{user.contact}}</li>
                        <li>{{user.address}}</li>
                        <li>{{user.email}}</li>
                    </ul>
                </div>

                <div *ngIf="user.category" class="single-resume-category single-resume-types">
                  <h3>{{user.category.name}}</h3>

                  <ul>
                      <li><a href="#">Total Views</a><span class="badge">{{user.serviceViews}}</span></li>
                  </ul>
                </div>

            </div>
        </div>
      </div>
  </div>
</div>


